var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c("ds-date-picker", {
        staticStyle: { width: "100%" },
        attrs: {
          type: _vm.pickerType,
          "period-type": _vm.chooseType,
          format: _vm.format,
          "value-format": _vm.valueFormat,
          clearable: _vm.item.isClearable !== false,
          popperClass: "ds-date-picker-panel",
        },
        on: { change: _vm.change },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }